module.exports = __webpack_public_path__ + "img/car-10.c0c38178.jpg";